/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import PageBox from "../../layouts/pageBox";
import FaqAccordion from "../../elements/FaqAccordion";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";

const Faq = () => {

    const { t, i18n } = useTranslation();

    const data = {
        title: 'F.A.Q.',
        subtitle: ''
    };

    const faqs = [
        {
            title : t('faq.question1' ),
            content : t('faq.answer1' )
        },
        {
            title : t('faq.question2' ),
            content : t('faq.answer2' )
        },
        {
            title : t('faq.question3' ),
            content : t('faq.answer3' )
        },
        {
            title : t('faq.question4' ),
            content : t('faq.answer4' )
        },
        {
            title : t('faq.question5' ),
            content : t('faq.answer5' )
        },
        {
            title : t('faq.question6' ),
            content : t('faq.answer6' )
        },
        {
            title : t('faq.question7' ),
            content : t('faq.answer7' )
        },
        {
            title : t('faq.question8' ),
            content : t('faq.answer8' )
        },
        {
            title : t('faq.question9' ),
            content : t('faq.answer9' )
        },
        {
            title : t('faq.question10' ),
            content : t('faq.answer10' )
        },
        {
            title : t('faq.question11' ),
            content : t('faq.answer11' )
        },
        {
            title : t('faq.question12' ),
            content : t('faq.answer12' )
        }
    ];

    return (
        <>
            <SEO
                title="Frequently Asked Questions"
                description="Frequently Asked Questions"
            />
            <PageBox data={data}>
                <div className='page-body'>

                    {
                        faqs.map((faq, index) =>
                            <FaqAccordion title={faq.title} content={faq.content} key={index}/>
                        )
                    }

                </div>
            </PageBox>
        </>

    );
};

export default Faq;
